export const EmployeeLeavesInfo = {
    leaveDate: "",
    leaveType: "",
    leaveStatus: "pending",
    leaveStartDate: "",
    leaveEndDate: "",
    leaveReason: "",
    leaveReasonType: "",
  };